<!--
 * @Autor: zhiying Qin
 * @Date: 2025-04-09 23:12:00
 * @LastEditTime: 2025-06-14 18:45:23
-->
<template>
  <div class="tool">
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item>
        <img src="@/assets/banner2.jpg" alt="" style="width: 100%" />
        <!-- <van-image width="100%" fit="contain" src="" /> -->
      </van-swipe-item>
      <van-swipe-item>
        <img src="@/assets/banner2.jpg" alt="" style="width: 100%" />
        <!-- <van-image width="100%" fit="contain" src="" /> -->
      </van-swipe-item>
    </van-swipe>
    <div class="min_box">
      <div class="min_item">
        <div style="width: 48%">
          <img src="@/assets/1.jpg" alt="" style="width: 100%" />
        </div>
        <div style="width: 48%">
          <img src="@/assets/3.jpg" alt="" style="width: 100%" />
        </div>
      </div>
      <div class="min_item">
        <div style="width: 48%">
          <img src="@/assets/2.jpg" alt="" style="width: 100%" />
        </div>
        <div style="width: 48%">
          <img src="@/assets/4.jpg" alt="" style="width: 100%" />
        </div>
      </div>
    </div>
    <div class="text">企业名录</div>
    <div class="listPost">
      <div class="ui-content">
        <li v-for="item in listData" :key="item.index" class="li-items" @click="toUrl('/enterpriseList')">
          <h2 style="font-size: 16px; position: relative; padding: 0px 10px">
            {{ item.companyName }}
          </h2>
          <div style="margin: 10px">
            <div class="title">
              {{ item.companyName }}

              <!-- <div class="ribbon" v-if="item.companyType == 2">
                      <div class="ribbon-text">大厂</div>
                    </div> -->
            </div>
            <div class="items-content">
              <p class="tag">
                <van-tag type="primary" style="margin-right: 10px">{{
                  getPostStatus('companyScaleList', 'scale', item)
                }}</van-tag>
                <van-tag type="primary" style="margin-right: 10px">{{
                  getPostStatus('companyTypeList', 'companyType', item)
                }}</van-tag>
                <!-- <van-tag type="primary" style="margin-right: 10px">{{
                        item.graduationYear
                      }}</van-tag> -->
              </p>

              <ol>
                <li>
                  <span class="label">企业类型：</span>
                  <span class="label-content" style="line-height: 16px">{{
                    getPostStatus('companyMoldList', 'companyMold', item)
                  }}</span>
                </li>
                <li>
                  <span class="label">行业：</span>
                  <span class="label-content">{{ item.profession }}</span>
                </li>
                <li>
                  <span class="label">主管部门：</span>
                  <span class="label-content">{{ item.manageSection }}</span>
                </li>
                <li>
                  <span class="label">总部地址：</span>
                  <span class="label-content">{{ item.officeAddress }}</span>
                </li>
                <li>
                  <span class="label">企业地址：</span>
                  <span class="label-content">{{ item.location }}</span>
                </li>
                <li>
                  <span class="label">企业介绍：</span>
                  <span class="label-content">{{ item.introduce }}</span>
                </li>
              </ol>
            </div>
            <!-- <div class="items-content-footer">
                    <van-icon
                      :name="item.isCollect ? 'star' : 'star-o'"
                      size="20"
                      :color="item.isCollect ? 'orange' : ''"
                      @click="postCollect(item)"
                    />

                    <van-button
                      type="info"
                      size="small"
                      round
                      @click="copyUrl(item.sendLink)"
                      >报考链接</van-button
                    >
                  </div> -->
          </div>
        </li>
      </div>
    </div>
    <!-- <div class="content">
      <ul>
        <li v-for="(item, index) in list" :key="index" @click="toUrl(item.path)">
          <p>
            <svg class="icon" aria-hidden="true">
              <use :xlink:href="'#' + item.icon"></use>
            </svg>
          </p>
          <p style="margin: 8px 0px;font-size: 14px;">{{ item.name }}</p>
        </li>
      </ul>
    </div> -->
    <!-- <van-icon name="bookmark-o" /> -->
    <van-tabbar v-model="active">
      <van-tabbar-item icon="home-o">首页</van-tabbar-item>
      <van-tabbar-item icon="orders-o" @click="toUrl('/enterpriseList')"
        >企业名录</van-tabbar-item
      >
      <van-tabbar-item icon="apps-o" @click="toUrl('/intelligencePost')"
        >标准筛岗</van-tabbar-item
      >
      <van-tabbar-item icon="bookmark-o" @click="toUrl('/precisePost')"
        >智能筛岗</van-tabbar-item
      >
      <!-- <van-tabbar-item icon="setting-o" replace to="/home">重点标识</van-tabbar-item> -->
      <van-tabbar-item icon="manager-o" @click="toUrl('/myCollect')"
        >我的收藏</van-tabbar-item
      >
    </van-tabbar>
  </div>
</template>

<script>
import Vue from 'vue'
import { Image as VanImage } from 'vant'
import axios from 'axios'
Vue.use(VanImage)
import { Tabbar, TabbarItem } from 'vant'
Vue.use(Tabbar)
Vue.use(TabbarItem)
import { Toast } from 'vant'
import { companyList, getDictType } from '@/api/xicaiquan'
export default {
  name: 'tool',
  data () {
    return {
      active: 0,
      icon: {
        active: 'https://img01.yzcdn.cn/vant/user-active.png',
        inactive: 'https://img01.yzcdn.cn/vant/user-inactive.png'
      },
      notices: [],
      list: [
        {
          name: '标准筛岗',
          path: '/precisePost',
          icon: 'icon-jingzhunpipei'
        },
        {
          name: '智能筛岗',
          path: '/intelligencePost',
          icon: 'icon-zhinengpipei'
        },
        {
          name: '重点标识',
          path: '',
          icon: 'icon-a-v02-zhongdianbiaoshixiao'
        },
        {
          name: '企业名录',
          path: '',
          icon: 'icon-qiyeminglu'
        },
        {
          name: '我的收藏',
          path: '/myCollect',
          icon: 'icon-wodeye_wodeshoucang'
        }
      ],
      queryParams: {
        current: 1,
        size: 10,
        companyName: ''
      },
      listData: [],
      companyMoldList: [],
      companyScaleList: [],
      companyTypeList: []
    }
  },
  created () {
    Promise.all([
      this.getDictType('company_mold', 'companyMoldList'),
      this.getDictType('company_scale', 'companyScaleList'),
      this.getDictType('company_company_type', 'companyTypeList')
    ]).then(res => {
      this.getData()
    })
  },
  components: {},
  watch: {},
  methods: {
    async fetchNotices () {
      try {
        const response = await axios.get(
          'https://api4.iguopin.com/api/notice/list',
          {
            params: {
              page: 1,
              per_page: 20,
              type: 'sasac',
              keyword: '' // 根据需要填写关键词，如果为空则留空字符串
            }
          }
        )
        this.notices = response.data
      } catch (error) {
        console.error('Error fetching notices:', error)
      }
    },
    async getData () {
      const res1 = await companyList(this.queryParams)
      let data = (res1.data && res1.data.records) || []

      this.listData = data
    },
    getPostStatus (target, prop, row) {
      const item = this[target].find(item => item.value == row[prop])

      if (item) {
        return item.text
      } else {
        return '无'
      }
    },
    async getDictType (type, target, callback) {
      return new Promise(async (resolve, reject) => {
        const res = await getDictType(type)
        if (res.code == 200) {
          resolve()
          res.data.forEach(item => {
            this[target].push({
              text: item.dictLabel,
              value: item.dictValue
            })
          })
        } else {
          reject()
        }
      })
    },
    toUrl (path) {
      if (!path) {
        Toast('功能开发中')
        return
      }

      this.$router.replace({ path })
    }
  }
}
</script>
<style scoped lang="scss">

.van-tabbar {
  width: 100vw;
}
.text {
  width: 100%;
  background-color: white;
  font-size: 20px;
  // line-height: 40px;
  font-weight: bold;
  padding: 16px 10px;
  padding-top: 18px;
  margin-bottom: 30px;
  // padding-bottom: 200px;
}
.min_box {
  width: 100%;
  margin: 0 auto;
  padding: 0 5px;
  padding-top: 18px;
  background-color: white;
  .min_item {
    width: 100%;
    display: flex;
    justify-content: space-between;
    justify-items: center;
  }
}

.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
  font-size: 40px;
}

.tool {
  width: 100%;
  height: 100vh;
  background: #f3f6f9;

  .content {
    width: 95%;
    height: 300px;
    border-radius: 10px;
    background: #fff;
    margin: 30px auto;

    ul {
      display: flex;

      li {
        width: 80px;
        height: 50px;
        // box-shadow: 0px 0px 0px 1px #ddd;
        text-align: center;
        // line-height: 50px;
        margin-right: 10px;
        margin-top: 50px;
      }
    }
  }
}

.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  // line-height: 150px;
  text-align: center;
  background-color: #39a9ed;
}

.listPost {
  width: 100%;
  padding-bottom: 80px;
  .ui-content {
    width: 95%;
    margin: 0px auto;
    
    .li-items {
      border-radius: 10px;
      background: #fff;
      margin-bottom: 20px;
      h2 {
        border-bottom: 1px solid #ddd;
        line-height: 40px;
        padding: 10px;
      }

      .title {
        background: #e0edfe;
        border-radius: 10px 10px 0px 0px;
        line-height: 40px;
        font-size: 16px;
        text-indent: 20px;
        margin-top: 20px;
        position: relative;
        overflow: hidden;
        padding-right: 10px;
        text-overflow: ellipsis;
        white-space: nowrap;

        .ribbon {
          width: 80px;
          height: 40px;
          background: orange;
          position: absolute;
          top: 0;
          right: -25px;
          transform: rotate(34deg);
          transform-origin: top right;
          box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
        }

        .ribbon-text {
          position: absolute;
          top: 12px;
          right: 12px;
          color: white;
          font-weight: bold;
          font-size: 12px;
          transform: rotate(0deg);
          transform-origin: right center;
          font-family: 'Arial', sans-serif;
        }

        /* 可选：让角标右上角带圆角 */
        .ribbon::before {
          content: '';
          position: absolute;
          top: 0;
          right: 0;
          width: 12px;
          height: 12px;
          background: white;
          border-top-left-radius: 12px;
        }
      }

      .items-content {
        background: #fafbff;
        padding: 20px;
        .tag {
          display: flex;
        }

        ol {
          margin: 20px 0px;
          li {
            display: flex;
            margin: 20px 0px;
            word-break: break-word;
            .label {
              color: #999;
              white-space: nowrap;
              display: block;
              width: 70px;
              text-align: right;
            }
            .label-content {
              line-height: 20px;
              flex: 1;
            }
          }
        }
      }

      .items-content-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid #ddd;
        padding: 14px 10px;
        background: #fafbff;
      }
    }
  }
}
</style>
